<script setup lang="ts">
import { computed } from 'vue'
import { AccessPointsUtil, type AccessPointLevel } from '@/util/access_points'
import type { ObjectiveLevel } from '@/goals/objectives/objective_levels'

const props = defineProps<{
  goalUuid: string
  level: ObjectiveLevel
  apLevel: AccessPointLevel
}>()

const title = defineModel<string>('title', { required: true })
const text = defineModel<string>('text', { required: true })

const fieldId = (field: string) => `${props.goalUuid}-obj-${props.level}-${field}`
const accessPointLabel = computed(() => AccessPointsUtil.labelsMap[props.apLevel])
</script>

<template>
  <div>
    <div class="mb-4">
      <label :for="fieldId('title')" class="block mb-1 font-bold">{{ level }} Quarter Title | {{ accessPointLabel }}</label>
      <input
        :id="fieldId('title')"
        v-model="title"
        type="text"
        placeholder="Objective title"
        class="w-full h-10 px-3 text-md !font-regular text-gray-900 bg-white border border-gray-600 rounded-xs placeholder:text-gray-700 focus:outline-primary-400"
      >
    </div>
    <div class="mb-4">
      <label :for="fieldId('text')" class="block mb-1 font-bold">{{ level }} Quarter Text | {{ accessPointLabel }}</label>
      <textarea
        :id="fieldId('text')"
        v-model="text"
        placeholder="Objective text"
        class="w-full px-3 py-2 text-md text-gray-900 bg-white border border-gray-600 rounded-xs placeholder:text-gray-700 focus:outline-primary-400"
      />
    </div>
    <slot />
  </div>
</template>
